import TextField from "./fields/TextField";
import TextareaField from "./fields/TextareaField";
import EmailField from "./fields/EmailField";
import NumberField from "./fields/NumberField";
import DateField from "./fields/DateField";
import SelectField from "./fields/SelectField";
import CheckboxField from "./fields/CheckboxField";
import RadioField from "./fields/RadioField";
import MultiSelectField from "./fields/MultiSelectField";
import FileField from "./fields/FileField";

import "./FieldRenderer.css";

const fieldMap = {
  text: TextField,
  textarea: TextareaField,
  email: EmailField,
  number: NumberField,
  date: DateField,
  select: SelectField,
  checkbox: CheckboxField,
  radio: RadioField,
  multiselect: MultiSelectField,
  file: FileField,
};

export default function FieldRenderer({
  field,
  value,
  onChange,
  error,
  disabled = false,
}) {
  if (!field || field.hidden || field.is_active === false) {
    return null;
  }

  const Component = fieldMap[field.type];

  if (!Component) {
    return (
      <div className="dynamic-field dynamic-field--error">
        Onbekend veldtype: {field.type}
      </div>
    );
  }

  return (
    <div className={`dynamic-field dynamic-field--${field.width || "full"}`}>
      <Component
        field={field}
        value={value}
        onChange={onChange}
        error={error}
        disabled={disabled || field.read_only}
      />
    </div>
  );
}
